module.exports = __webpack_public_path__ + "static/media/man-search-hiring-job-online-from-laptop_1150-52728.745f67e9.png";